import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'store';

interface SignupSettings {
  hasTerms?: boolean;
  hasMarketing?: boolean;
}

interface UserSettingsSlice {
  signupSettings: SignupSettings;
}

const initialState: UserSettingsSlice = { signupSettings: {} };

export const userSettingsSlice = createSlice({
  name: 'userSettings',
  initialState,
  reducers: {
    setSignupSettings: (state, action: PayloadAction<SignupSettings>) => {
      const { hasMarketing, hasTerms } = action.payload;

      state.signupSettings = {
        ...state.signupSettings,
        hasMarketing,
        hasTerms,
      };
    },
  },
});

export const selectSignupSettings = (state: RootState) =>
  state.userSettings.signupSettings || {};

export const { setSignupSettings } = userSettingsSlice.actions;
